<script setup lang="ts">
import type { CustomerTypeEnum, Identification } from '~/layers/forms/models'
import { Form } from '~/layers/forms/models'

interface Props {
  modelValue: Identification
  validationScope?: string
  registerValidationAs?: string
  ignoreValidations?: boolean
  entityType?: PropsTypesOf<typeof CustomerTypeEnum>['code'] | null
}

const props = withDefaults(defineProps<Props>(), {
  validationScope: Form.identification,
  registerValidationAs: Form.identification,
  entityType: null,
})

const { RemoteConfigurationStore } = stores()

const heading = computed(
  () =>
    `Documento de identificación del ${RemoteConfigurationStore.value?.ramoEnum === 'Personas' ? 'asegurado' : 'contratante'}`
)
</script>

<template>
  <FormsGlobalContainer :identifier="Form.identification">
    <FormsGlobalTitle
      :text="heading"
      icon-class="icon-[ph--user-list-bold]"
      class="col-span-full"
    />
    <FormsIdentificationFields v-bind="props" />
  </FormsGlobalContainer>
</template>
